import { ReviewType } from '..';
import Review from './Review';

type ModalResultsType = {
  reviews: ReviewType[];
};

const ModalResults = ({ reviews }: ModalResultsType) => {
  return (
    <ul className="mt-36 max-h-[400px]">
      {reviews.map((review, index) => (
        <Review review={review} key={index} />
      ))}
    </ul>
  );
};

export default ModalResults;
